'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var util = require('@ks/kwai-ui/lib/utils/util');

function isVNode(node) {
  return node !== null && typeof node === 'object' && util.hasOwn(node, 'componentOptions');
}

exports.isVNode = isVNode;
